import React from "react";
import Product from "../Components/product/Product";
import Spacer2 from "../Components/common/Spacer2";
import PageHeader from "../Components/common/PageHeader";
import SEO from "../Components/common/SEO";
import { useTranslation } from "react-i18next";

function ProductPage() {
  const { t } = useTranslation();
  const siteUrl = 'https://seymenkimya.com';
  const pageUrl = `${siteUrl}/urunlerimiz`;

  const collectionStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    'name': 'Seymen Kimya Ürünleri',
    'description': 'Profesyonel temizlik ve kimyasal ürünler koleksiyonu',
    'url': pageUrl,
    'mainEntity': {
      '@type': 'ItemList',
      'name': 'Temizlik Ürünleri',
      'description': 'Endüstriyel ve ev tipi temizlik ürünleri',
      'numberOfItems': 12,
      'itemListElement': [
        {
          '@type': 'Product',
          'name': 'Kireç Çözücü',
          'url': `${siteUrl}/kireccozucu`
        },
        {
          '@type': 'Product', 
          'name': 'Bulaşık Makina Deterjanları',
          'url': `${siteUrl}/bulasikmakinedeterjanlari`
        },
        {
          '@type': 'Product',
          'name': 'Çamaşır Suyu',
          'url': `${siteUrl}/camasirsuyu`
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Ürünlerimiz | Profesyonel Temizlik Ürünleri - Seymen Kimya"
        description="Seymen Kimya'nın geniş ürün yelpazesini keşfedin. Bulaşık deterjanı, kireç çözücü, çamaşır suyu ve daha fazlası. Kaliteli temizlik çözümleri."
        canonical={pageUrl}
        image={`${siteUrl}/assets/images/product/products-collection.webp`}
        structuredData={collectionStructuredData}
      />
      <PageHeader className="mb-5" title={t("ÜRÜNLERİMİZ")} />
      <Spacer2 />
      <Product />
    </>
  );
}

export default ProductPage;
